import React, { useCallback, useContext, useMemo } from 'react';
import { isEmpty } from 'lodash';
import { Redirect, useParams } from 'react-router-dom';
import ProgressBackdrop from '../../preorder/components/ProgressBackdrop';
import Provider from '../components/Provider';
import displayDataContext from '../contexts/displayData';
import favoriteItemsContext from '../contexts/favoriteItems';
import providersContext from '../contexts/providers';

export default () => {
  const params = useParams();
  const { displayData } = useContext(displayDataContext);
  const { isLoading } = useContext(providersContext);
  const {
    isLoading: favoriteItemsIsLoading,
    toggleItems,
  } = useContext(favoriteItemsContext);
  const { name } = params || {};

  const provider = useMemo(() => displayData.find((p) => {
    const { name: providerName } = p || {};

    return name === providerName;
  }), [displayData, name]);

  const onFavoriteButtonClick = useCallback(async ({ itemId, itemType, type }) => {
    await toggleItems([{ itemId, itemType, type }]);
  }, [toggleItems]);

  if (
    isLoading
    || favoriteItemsIsLoading
    || isEmpty(displayData)
  ) return <ProgressBackdrop isShow />;
  if (!name) return <Redirect to="/providers" />;
  if (!provider) return <Redirect to="/providers" />;

  return (
    <Provider
      data={provider}
      onFavoriteButtonClick={onFavoriteButtonClick}
    />
  );
};
